import React from 'react';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import TopFeatureList from '../../../components/TopFeature/TopFeatureList';
import messages from '../../../locale/messages';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './TopFeature.css';
class TopFeature extends React.Component {

    render() {
        const { formatMessage } = this.props.intl;
        return (
            <div className={s.root}>
                <div className={s.container}>
                    <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>
                        {formatMessage(messages.aboutSectionSettings)}
                    </div>
                    <div className={s.paddingRoutesSection}>
                        <TopFeatureList />
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(injectIntl, withStyles(s))(TopFeature);